var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2545_775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6154 4.89673C12.5131 4.57118 12.3088 4.28719 12.0326 4.08675C11.7564 3.88631 11.4231 3.78007 11.0819 3.78373H8.89736L8.23386 1.71573C8.12952 1.39021 7.9245 1.10624 7.64835 0.904766C7.3722 0.703291 7.0392 0.594727 6.69736 0.594727C6.35553 0.594727 6.02253 0.703291 5.74638 0.904766C5.47023 1.10624 5.2652 1.39021 5.16086 1.71573L4.49736 3.78373H2.31286C1.97273 3.78422 1.64146 3.89218 1.36635 4.09219C1.09125 4.2922 0.886382 4.57403 0.781023 4.89743C0.675663 5.22083 0.675197 5.56925 0.77969 5.89293C0.884184 6.21661 1.08829 6.49899 1.36286 6.69973L3.14086 7.99973L2.46486 10.0932C2.35562 10.4179 2.35423 10.7692 2.46092 11.0948C2.5676 11.4203 2.77664 11.7027 3.05686 11.8997C3.33229 12.1031 3.66606 12.2121 4.00844 12.2104C4.35082 12.2087 4.68348 12.0964 4.95686 11.8902L6.69736 10.6092L8.43836 11.8887C8.71329 12.091 9.04526 12.2008 9.38655 12.2025C9.72783 12.2041 10.0609 12.0975 10.3377 11.898C10.6146 11.6985 10.8211 11.4163 10.9275 11.092C11.0339 10.7677 11.0347 10.418 10.9299 10.0932L10.2539 7.99973L12.0339 6.69973C12.3116 6.50151 12.5181 6.21913 12.6228 5.89441C12.7275 5.56968 12.7249 5.21986 12.6154 4.89673Z",
    fill: "#FFC700"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2545_775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.697266 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/starFilled.7908dd8e7cedeab7f23b9c8137123f30.svg";
export { ForwardRef as ReactComponent };